import { useEffect, useState } from 'react';
import { StatusCodes } from 'http-status-codes';
import { Row, Col } from 'react-bootstrap';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import ProductImportsApi from '../../../../services/api/ProductImportsApi';
import MatchRow from '../components/MatchRow';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import { useHistory } from 'react-router-dom';

export default function MatchChocolateToGtin(): JSX.Element {
  const [matches, setMatches] = useState([]);
  const [currentMatch, setCurrentMatch] = useState(null);
  const url = `${API_URL}/products/imports/get-searches`;
  const history = useHistory();
  
  const getMatches = async () => {
    const res = await ProductImportsApi.getMatches();

    if (res.status === StatusCodes.OK) {
      res.data.sort((a, b) => (a.nameChocolateSite > b.nameChocolateSite ? 1 : -1));
      const unready = res.data.filter((item) => item.marked === false);
      const ready = res.data.filter((item) => item.marked === true);
      setMatches([...unready, ...ready]);
    }
  };

  const onRowClick = async (rowInfo) => {
    currentMatch.marked = true;
    currentMatch.gtinCu = rowInfo.dataItem.gtin;
    var res = await ProductImportsApi.saveMatch(currentMatch);

    if (res.status === StatusCodes.OK) {
      const data = [...matches];
      data.forEach((element) => {
        if (element.id === currentMatch.id) {
          element = res.data;
        }
      });
      setMatches(data);
      setCurrentMatch(null);
    }
  };


  const StatefullGrid = withState(Grid, url, { onRowClick });

  useEffect(() => {
    getMatches();
  }, []);

  const selectCurrent = (item) => {
    if (currentMatch?.id === item.id) {
      setCurrentMatch(null);
    } else {
      setCurrentMatch(item);
    }
  };

  const handleNoMatch = async (item) => {
    var res = await ProductImportsApi.noMatch(item.id);

    if (res.status === StatusCodes.OK) {
      const data = [...matches];
      data.forEach((element) => {
        if (element.id === item.id) {
          element = res.data;
        }
      });
      setMatches(data);
      setCurrentMatch(null);
    }
  };

  const getFirstTwoWords = () => {
    const firstTwoWords = currentMatch.nameChocolateSite.split(' ').slice(0, 1);
    const firstTwoWordsString = firstTwoWords.join(' ');
    return firstTwoWordsString;
  };

  return (
    <WhitePad isFluid>
      <TitleComponent title="Matching Chocolate Brand Name to CU GTIN" 
      titleLeft="Back"
      onLeftHandler={(): void => history.goBack()}
      />
      <Row>
        <Col>
          Currently Selected:
          {currentMatch?.nameChocolateSite}
        </Col>
      </Row>
      <Row>
        <Col>
          {matches?.map((item) => {
            
            return (
              <MatchRow
                item={item}
                key={item.id}
                onClickX={selectCurrent}
                onNoMatch={handleNoMatch}
                selected={currentMatch?.id === item.id}
              />
            );
          })}
        </Col>
        <Col>
          {currentMatch && (
            <GridWrapper>
              <StatefullGrid
                state={{
                  dataState: {
                    skip: 0,
                    take: 1000,
                    filter: {
                      logic: 'and',
                      filters: [
                        {
                          field: 'name',
                          operator: 'contains',
                          value: getFirstTwoWords(currentMatch.nameChocolateSite),
                        },
                      ],
                    },
                  },
                  loading: false,
                }}
              >
                <GridColumn field="name" title="Name" />
                <GridColumn field="gtin" title="Gtin" />
              </StatefullGrid>
            </GridWrapper>
          )}
        </Col>
      </Row>
    </WhitePad>
  );
}
